/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */

import SSCartesian from './sscartesian';
import {
  __feedAxesRawData,
  __spaceManager,
  __postSpaceManagement
} from './msbarcartesian';

/**
 * This class is base class for single series bar charts.
 */
class SSBarCartesian extends SSCartesian {
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'SSBarCartesian';
  }
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'SSBarCartesian';
  }

  /**
   * This method parse all the attributes which are associated with axis compoenents.
   * So that axis compoenents can be configured
   * @return { Object } contains axes config
   */
  _feedAxesRawData () {
    return __feedAxesRawData.call(this);
  }
  /**
   * This method first assigns the entire area of the chart to canvas. Then every component (for example toolbox,
   * caption etc) is asked to allocate its own space. Once every compoenent has had its space allocated, the canvas is
   * assigned the remaining space.
   */
  _spaceManager () {
    __spaceManager.call(this);
  }
  /**
   * This function is adjusting value padding depending upon data and axis labels and set dimention to axis
   */
  _postSpaceManagement () {
    __postSpaceManagement.call(this);
  }
}
export default SSBarCartesian;
